import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_ACCESS} from '../../constants';

export default {
  id: 'ROLE',
  title: 'Was ist meine Rolle?',
  description: '',
  categories: [CONTENT_CATEGORY_ACCESS],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Um Ihre Rolle zu kennen, gehen Sie auf die Registerkarte "Einstellungen" und dann auf "Nutzer".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ROLE/DE_ROLE_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Bei OnceForAll sind mehrere Benutzerrollen verfügbar.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Hier ist die Liste der verschiedenen Rollen:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Account Manager: Dies ist der Kontoverwalter. Er/sie aktualisiert Dokumente, verwaltet Unternehmensbeziehungen und verwaltet die mit dem Unternehmen verbundenen Benutzer'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Gast: Er verwaltet hauptsächlich die Beziehungen des Unternehmens (Kunden/Lieferanten)'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Berater: Er kann einfach die Unterlagen der Lieferanten einsehen. Er kann auch die Datei seiner Firma einsehen'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Beobachter: Er kann nur seine Lieferanten konsultieren und einladen'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Jeder Benutzer einer Einrichtung kann seine Rolle, seine Berechtigungen und die der anderen einsehen.'
  }]
};
